import { preparePrinterArabicText } from '../../../../utils/arabicPrintUtils';

const createItems = (order, t, language, formatCurrency) => {
  const items = order.items.map(item => {
    let itemName = language === 'ar' ? item.name_ar || item.name : item.name;
    // Apply special formatting to Arabic item names that prevents wrapping
    if (language === 'ar') {
      // Modify the style to enforce nowrap
      itemName = `<span style="
        font-family: Tahoma, Arial, 'Simplified Arabic', sans-serif;
        direction: rtl;
        unicode-bidi: bidi-override;
        text-align: right;
        white-space: nowrap;
        letter-spacing: 0;
        display: inline-block;
      ">${itemName}</span>`;
    }
    // Don't truncate item names
    const displayName = itemName;
    
    
    // Make sure we get a valid price
    let itemPrice = parseFloat(item.price) || 0;
    let itemQuantity = Math.max(1, parseFloat(item.quantity) || 1);
    
    // Calculate unit price and total price, ensuring we don't divide by zero
    const unitPrice = item.unit_price > 0 ? item.unit_price : (itemPrice / itemQuantity);
    const totalItemPrice = unitPrice * itemQuantity;
    
    // Format for display
    const price = formatCurrency(totalItemPrice);
    
    // Update item.price with the total price to ensure correct subtotal calculation
    item.price = totalItemPrice;
    
    return `
      <tr class="item-row">
        <td style="
          text-align: ${language === 'ar' ? 'right' : 'left'};
          padding: 1.5mm ${language === 'ar' ? '0 1.5mm 2mm' : '2mm 1.5mm 0'};
          border-bottom: 1px dashed #000;
          width: 60%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        ">${displayName}</td>
        <td style="
          text-align: center;
          width: 30px;
          padding: 1.5mm 0;
          border-bottom: 1px dashed #000;
          font-family: Tahoma, Arial, sans-serif;
        ">${item.quantity}</td>
        <td style="
          text-align: ${language === 'ar' ? 'left' : 'right'};
          width: 30%;
          padding: 1.5mm ${language === 'ar' ? '0 1.5mm 2mm' : '2mm 1.5mm 0'};
          border-bottom: 1px dashed #000;
          font-family: Tahoma, Arial, sans-serif;
        ">${price}</td>
      </tr>
      ${item.notes ? `
        <tr>
          <td colspan="3" style="
            padding: 0.5mm 2mm 1mm 2mm;
            font-size: 8pt;
            color: #666;
            font-style: italic;
          ">* ${item.notes}</td>
        </tr>
      ` : ''}
    `;
  }).join('');

  return `
    <div style="margin: 2mm 0;">
      <table style="
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 2mm;
        table-layout: fixed;
      ">
        <thead>
          <tr>
            <th style="
              text-align: ${language === 'ar' ? 'right' : 'left'};
              padding: 2mm 1mm;
              border-bottom: 2px solid #000;
              font-size: 10pt;
            ">${language === 'ar' ? preparePrinterArabicText(t('cashier.receipt.items.name')) : t('cashier.receipt.items.name')}</th>
            <th style="
              text-align: center;
              width: 30px;
              padding: 2mm 1mm;
              border-bottom: 2px solid #000;
              font-size: 10pt;
            ">${language === 'ar' ? preparePrinterArabicText(t('cashier.receipt.items.quantity')) : t('cashier.receipt.items.quantity')}</th>
            <th style="
              text-align: ${language === 'ar' ? 'left' : 'right'};
              width: 30%;
              padding: 2mm 1mm;
              border-bottom: 2px solid #000;
              font-size: 10pt;
            ">${language === 'ar' ? preparePrinterArabicText(t('cashier.receipt.items.price')) : t('cashier.receipt.items.price')}</th>
          </tr>
        </thead>
        <tbody>
          ${items}
        </tbody>
      </table>
    </div>
  `;
};


export default createItems;
